// Onboarding-run observe types, mirroring RunOut/RunDetailOut/RunStepOut/
// ArtifactPinOut in api/v1/onboarding_runs.py (post-F2 serializer add). F2 is
// observe-only through F2; F3 adds create/lifecycle input types.

export type RunStatus =
  | "draft"
  | "previewed"
  | "approved"
  | "queued"
  | "claimed"
  | "running"
  | "succeeded"
  | "failed"
  | "cancelled"
  | "needs_reconciliation";

export type LockScope = "site" | "tenant" | "account";

export type ExecutionKind = "ansible" | "api";

export type RunStepStatus = "pending" | "running" | "succeeded" | "failed" | "skipped";

export const RUN_STATUSES: ReadonlyArray<{ value: RunStatus; label: string }> = [
  { value: "draft", label: "Draft" },
  { value: "previewed", label: "Previewed" },
  { value: "approved", label: "Approved" },
  { value: "queued", label: "Queued" },
  { value: "claimed", label: "Claimed" },
  { value: "running", label: "Running" },
  { value: "succeeded", label: "Succeeded" },
  { value: "failed", label: "Failed" },
  { value: "cancelled", label: "Cancelled" },
  { value: "needs_reconciliation", label: "Needs reconciliation" },
];

export interface RunOut {
  id: string;
  tenant_id: string;
  site_id: string | null;
  run_type: string;
  execution_kind: ExecutionKind;
  status: RunStatus;
  status_reason: string | null;
  lock_scope: LockScope;
  lock_key: string;
  playbook_commit: string | null; // ansible-only
  executor_ref: string | null; // api-only (deployed Hub build)
  diff_version: string | null;
  approval_binding: Record<string, unknown> | null;
  approved_by: string | null;
  created_at: string;
  approved_at: string | null;
  claimed_by: string | null;
  lease_expires_at: string | null;
  heartbeat_at: string | null;
}

export interface ArtifactPinOut {
  kind: string; // "input" | "output"
  name: string;
  content_sha256: string;
}

export interface RunStepOut {
  ord: number;
  name: string;
  status: RunStepStatus;
  started_at: string | null;
  finished_at: string | null;
}

export interface RunDetailOut extends RunOut {
  artifacts: ArtifactPinOut[];
  steps: RunStepOut[];
}

export interface RunListFilters {
  status?: RunStatus;
  tenant_slug?: string;
  site_slug?: string;
}


export interface ArtifactRefIn {
  name: string;
  content_sha256: string;
}

export interface RunCreateIn {
  run_type: string;
  tenant_slug?: string | null;
  site_slug?: string | null;
  artifacts: ArtifactRefIn[];
  generator_version: string;
  artifact_schema_version: number;
  run_type_version: number;
  // ansible run types send a 40-hex git sha; api run types send NO commit
  // (executor_ref is server-stamped). execution_kind/executor_ref are never
  // client-supplied.
  playbook_commit?: string | null;
}

export type PreviewDiffStatus = "added" | "changed" | "unchanged";

export interface PreviewDiff {
  artifacts: {
    name: string;
    previous_sha256: string | null;
    new_sha256: string;
    status: PreviewDiffStatus;
  }[];
}
